import { selectFetchingPostedJobs, selectPostedJobs } from '../../../../../store/workspace/selectors';
import { resetExamStatistics } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import MotionWrapper from '../../../../../layouts/MotionWrapper';
import JobCard from '../../../../../components/JobCard';
import Loading from '../../../../../components/Loading';
import styles from './style.module.scss';
import { useEffect, useState } from 'react';

type Tab = 'active' | 'closed';

function Jobs() {
    const dispatch = useDispatch();
    const [tab, setTab] = useState<Tab>('active');
    const fetchingJobs = useSelector(selectFetchingPostedJobs);
    const postedJobs = useSelector(selectPostedJobs);

    useEffect(() => {
        dispatch(resetExamStatistics());
    }, []);

    return (
        <MotionWrapper className={styles.container}>
            <span className={styles.title}>History</span>

            <div className={styles.tabs}>
                <div
                    className={styles.tabs_item}
                    onClick={() => setTab('active')}
                    data-is-active={tab === 'active'}
                >
                    <span>Active jobs ({postedJobs.filter(i => i.status !== 'ended' && i.status !== 'expired').length})</span>
                </div>
                <div
                    className={styles.tabs_item}
                    onClick={() => setTab('closed')}
                    data-is-active={tab === 'closed'}
                >
                    <span>Closed jobs ({postedJobs.filter(i => i.status === 'ended' || i.status === 'expired').length})</span>
                </div>
            </div>

            <div className={styles.jobs}>
                {tab === 'active' && (postedJobs.filter(i => i.status !== 'ended' && i.status !== 'expired').length > 0 ?
                    postedJobs.filter(i => i.status !== 'ended' && i.status !== 'expired').map(job => <JobCard detail={job} />)
                    : <div className={styles.empty}><span>No active jobs.</span></div>)}
                {tab === 'closed' && (postedJobs.filter(i => i.status === 'ended' || i.status === 'expired').length > 0 ?
                    postedJobs.filter(i => i.status === 'ended' || i.status === 'expired').map(job => <JobCard detail={job} />)
                    : <div className={styles.empty}><span>No closed jobs.</span></div>)}

                {postedJobs.length === 0 && fetchingJobs && <Loading />}
            </div>
        </MotionWrapper>
    )
};

export default Jobs;
